import { render, staticRenderFns } from "./UModal.vue?vue&type=template&id=f323c002&"
import script from "./UModal.vue?vue&type=script&lang=js&"
export * from "./UModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports